/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Grid} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Snackbar from "@material-ui/core/Snackbar";

import Sidebar from "./base/Sidebar";
import PhotosComponent from "../components/Photo/PhotosComponent";
import { SeoComponent } from "../components/Header/SeoComponent";
import { usePhotoBaseData } from "../context/PhotoBasicDataContext";
import { useThemeData } from "../context/ThemeDataContext";
import { useAuthData } from "../context/AuthProvider";

/* HOMEPAGE PHOTO OVERVIEW*/
function Home(props) {
  const { site_name } = useThemeData().themeData.site;
  const { font_family, primary_color_5, favicon } = useThemeData().themeData.site.theme;
  const { hide_category_side_bar } = useThemeData().modules;
  const { category_id } = useThemeData().categoryData;
  const select_photo = usePhotoBaseData().photoDefaultSettings.default_photo_id;
  const [photo, setPhoto] = useState({
    id: "",
    folderID: "",
    filename: "",
    categorie_id: category_id,
  });

  const keuzeset_id =
    usePhotoBaseData().photoDefaultSettings.default_keuzeset_id;
  const { auth } = useAuthData();
  const location = useLocation();

  const [alertStatus, setAlertStatus] = useState(
    location.state !== undefined && location.state !== null
      ? location.state.alertStatus
      : {
          success: {
            open: false,
            message: undefined,
          },
          error: {
            open: false,
            message: undefined,
          },
          horizontal: "center",
          vertical: "top",
        }
  );
  const { vertical, horizontal } = alertStatus;

  const changePhoto = (photoid, folderid, filename, categorie_id) => {
    //set photoid to the big picture
    setPhoto({
      id: photoid,
      folderID: folderid,
      filename: filename,
      categorie_id: categorie_id,
    });
  };

  let categoryArray = [];
  usePhotoBaseData().photoData.forEach((photo) => {
    photo.productcategory.forEach((category) => {
      categoryArray.push(category);
    });
  });

  function multiDimensionalUnique(arr) {
    var uniques = [];
    var itemsFound = {};
    for (var i = 0, l = arr.length; i < l; i++) {
      var stringified = JSON.stringify(arr[i]);
      if (itemsFound[stringified]) {
        continue;
      }
      uniques.push(arr[i]);
      itemsFound[stringified] = true;
    }
    return uniques;
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertStatus((prevState) => ({
      ...prevState,
      success: { open: false, message: "" },
      error: { open: false, message: "" },
    }));
  };

  return (
    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      xl={12}
      className="home"
      style={{
        fontFamily: `${font_family}`,
        color: `${primary_color_5}`,
      }}
    >
      <SeoComponent site_name={site_name} favicon={favicon} title="Shop" />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        name="success"
        open={alertStatus.success.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {alertStatus.success.message}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        name="error"
        open={alertStatus.error.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {alertStatus.error.message}
        </Alert>
      </Snackbar>
      <Grid container direction="row" spacing={4}>
        {hide_category_side_bar!=='true' && (
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <Sidebar
            className="sticky-state"
            select_photo={select_photo}
            keuzeset_id={keuzeset_id}
            auth={auth}
            categoryData={multiDimensionalUnique(categoryArray).sort(
              (a, b) => a.volgorde - b.volgorde
            )}
            historyHome={props.history}
          />
        </Grid>
        )}
        <Grid item xs={12} md={6} lg={4} xl={4}>
          <div className="highlighted photo">
            <PhotosComponent {...props} highlight={true} changedPhoto={photo} />
          </div>
        </Grid>
        <Grid item xs={12} md={12} lg={4} xl={5}>
          <div className="photos">
            <PhotosComponent
              {...props}
              changePhoto={changePhoto}
              update={props.update}
            />
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default React.memo(withTranslation("home")(Home));
